import { Button } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getMyProfile, qk } from 'api'
import { paths } from 'app/routes'
import { IconChangePlan } from 'assets/icons/toolbar/change-plan'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

export const MyPlanBadge = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data } = useQuery(qk.users.myProfile.toKey(), getMyProfile)

  if (!data) return null

  const planName = data.plan?.name
    ? data.plan.name.charAt(0).toUpperCase() + data.plan.name.slice(1)
    : null

  return (
    <Button
      aria-label="open-plans-page-button"
      sx={{
        color: 'text.primary',
        mr: 2,
        height: 25,
      }}
      variant="outlined"
      startIcon={<IconChangePlan sx={{ transform: 'rotate(-90deg)' }} />}
      onClick={e => {
        e.currentTarget.blur()
        navigate(paths.plans)
      }}
    >
      {planName ? t('plans.plan_with_name', { planName }) : t('common.plans')}
    </Button>
  )
}
